// extracted by mini-css-extract-plugin
export default {"bullet_text":"pdp-bullet_text"};